import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const ABDOMEN_FORM_INITIAL_VALUES = {
  sections: {
    postpartumAbdomen: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamPerineumAndExternalGenitaliaSections =
  keyof typeof ABDOMEN_FORM_INITIAL_VALUES.sections;
